import BaseService from "../BaseService";

export default class ListaAppuntamenti extends BaseService {

  static async getAppuntamenti(idStruttura, dataRiferimento){
    return await this.perform({
      url: '/operatori/agenda/lista/'+ idStruttura,
      method: 'get',
      headers: {},
      params: {
        dataRiferimento
      }
    })
  }

  static async printPrenotati(idStruttura, dataRiferimento){
    return await this.perform({
      url: '/operatori/agenda/printprenotati/'+ idStruttura,
      method: 'get',
      headers: {},
      params: {
        dataRiferimento
      }
    })
  }
}
